export default "__VITE_ASSET__cd8b3cde__"